import { AppConfigService } from '@/services/app-config.service';
import { Component, OnInit } from '@angular/core';
import { MatCheckboxChange, MatCheckboxModule } from '@angular/material/checkbox';
import { MatDialogRef, MatDialogModule } from '@angular/material/dialog';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { environment } from 'src/environments/environment';

import { NgTemplateOutlet } from '@angular/common';
import { ModalBaseComponent } from '../base/modal-base/modal-base.component';

@Component({
    selector: 'app-store-badge-dialog',
    templateUrl: './store-badge-dialog.component.html',
    styleUrls: ['./store-badge-dialog.component.scss'],
    standalone: true,
    imports: [ModalBaseComponent, NgTemplateOutlet, MatDialogModule, MatCheckboxModule]
})
export class StoreBadgeDialogComponent implements OnInit {
  dialogTitle = "Télécharger l'application EEMO";
  link: SafeResourceUrl;
  linkAsset: SafeResourceUrl;

  readonly assetsPath = '/assets/images';

  constructor(
    private appConfigService: AppConfigService,
    public dialogRef: MatDialogRef<StoreBadgeDialogComponent>,
    private sanitizer: DomSanitizer
  ) {}

  ngOnInit(): void {
    if (this.appConfigService.isOSiOS) {
      this.link = this.sanitizer.bypassSecurityTrustResourceUrl(environment.appLinkIOs);
      this.linkAsset = this.sanitizer.bypassSecurityTrustResourceUrl(this.assetsPath + '/app-store-badge.png');
    } else if (this.appConfigService.isOSAndroid) {
      this.link = this.sanitizer.bypassSecurityTrustResourceUrl(environment.appLinkAndroid);
      this.linkAsset = this.sanitizer.bypassSecurityTrustResourceUrl(this.assetsPath + '/google-play-badge.png');
    } else {
      // unmanaged OS: show nothing
      this.dialogRef.close(false);
    }
  }

  toggleDontShow(change: MatCheckboxChange) {
    this.appConfigService.showAppDownload = !change.checked;
  }
}
